import ApiTableContainer from '@console/containers/project/giftConfig/ApiTableContainer';
import GcpTableContainer from '@console/containers/project/giftConfig/GcpTableContainer';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import type { ReactNode } from 'react';
import { Fragment } from 'react';
import CommonErrorContainer from '../../containers/common/CommonErrorContainer';
import type {
  GiftConfigPropsMappedFromDispatch,
  GiftConfigPropsMappedFromState
} from '../../containers/project/GiftConfigContainer';
import BulkTableContainer from '../../containers/project/giftConfig/BulkTableContainer';

const styles = (): StyleRules => ({});

type GiftConfigProps = GiftConfigPropsMappedFromState &
  GiftConfigPropsMappedFromDispatch &
  WithStyles<typeof styles>;

// TODO: 綴り対応 & 選べる対応 & GiftCardConfig の issueAmountRequest 対応
const GiftConfig: React.FC<GiftConfigProps> = ({
  isApiProject,
  isBulkProject,
  isGcpProject
}) => {
  const renderTable = (): ReactNode => {
    if (isBulkProject) {
      return <BulkTableContainer />;
    }
    if (isApiProject) {
      return <ApiTableContainer />;
    }
    if (isGcpProject) {
      return <GcpTableContainer />;
    }

    return null;
  };

  return (
    <Fragment>
      <CommonErrorContainer />
      {renderTable()}
    </Fragment>
  );
};

export default withStyles(styles)(GiftConfig);
